<template>
  <div>
    <el-table :data="data" border height="100%" style="width: 100%">
      <el-table-column prop="id" label="任务号" width="80">
      </el-table-column>
      <el-table-column prop="period" label="周期(分)" width="80">
      </el-table-column>
      <el-table-column prop="recording_length" label="录音时长(秒)" width="110">
      </el-table-column>
      <el-table-column prop="detail" label="任务说明">
      </el-table-column>
      <el-table-column prop="last_execution" label="最近执行" width="160">
      </el-table-column>
      <el-table-column label="扫描频率">
        <template slot-scope="scope">
          <el-tag style="margin-left:1%" v-for="(value,key) in scope.row.freq_range" :key="key" type="success" size="small">
            {{parseFreqRange(value)}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showWhiteList(scope.$index)">白名单</el-button>
          <el-button type="text" size="small" @click="showTaskHistory(scope.$index)">执行历史</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination totalCountOrURL="/terminal/cnt_periodTaskRd" :params="{device_lgid:lgid}" @change="handlePageChange"></Pagination>
    <el-dialog :visible.sync="whiteListVisible" :close-on-click-modal='false'>
      <WhiteListOfTask ref="whiteListOfTask" :whiteListIds="whiteListIds"></WhiteListOfTask>
    </el-dialog>
    <el-dialog :visible.sync="taskHistoryVisible" :close-on-click-modal='false'>
      <PeriodTaskExcutionHistory ref="periodTaskExcutionHistory" :periodTaskId="periodTaskId" :deviceId="deviceId"></PeriodTaskExcutionHistory>
    </el-dialog>
  </div>
</template>

<script>
  import WhiteListOfTask from "@/components/Tables/WhiteListOfTask";
  import Pagination from "@/components/PageNations/Pagination";
  import PeriodTaskExcutionHistory from "@/components/Tables/PeriodTaskExcutionHistory";
  export default {
    props: ["lgid"],
    components: {
      WhiteListOfTask,
      Pagination,
      PeriodTaskExcutionHistory
    },
    mounted() {
      this.getData();
    },
    watch: {
      lgid() {
        this.getData();
      }
    },
    data() {
      return {
        selected_idx: "",
        whiteListVisible: false,
        whiteListIds: null,
        taskHistoryVisible: false,
        periodTaskId: null,
        deviceId: null,
        data: [],
        page: 1,
        size: 10
      };
    },
    methods: {
      handlePageChange(params) {
        this.page = params.page;
        this.size = params.size;
        this.getData();
      },
      showWhiteList(index) {
        this.whiteListVisible = true;
        this.whiteListIds = this.data[index].whitelist;
      },
      showTaskHistory(index) {
        this.taskHistoryVisible = true;
        this.periodTaskId = this.data[index].id;
        this.deviceId = this.lgid;
      },
      parseFreqRange(range) {
        if (range.length == 1) {
          return `${range[0]}`;
        } else {
          return `${range[0]}-${range[1]}`;
        }
      },
      getData() {
        if (this.lgid) {
          this.$getJSON("/terminal/s_periodTaskRd", {
            device_lgid: this.lgid,
            page: this.page,
            size: this.size
          }).then(res => {
            this.data = res.data;
          });
        }
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Tables/PeriodTaskRd.vue